/* Corte de pedidos (snippets/ficha-corte.liquid; ADR-0020, punto 4; 22-10-2026). La hora es la de Madrid para todos, nunca la del dispositivo
   (Intl.DateTimeFormat con timeZone Europe/Madrid; el instante del corte sale en dos pasadas, así que aguanta el cambio de hora). Sin cookies ni
   almacenamiento: no guarda nada del visitante. Repinta cada 15 s, con los minutos redondeados hacia abajo. Con el contador con fecha a la vista
   ([data-ficha-countdown] con data-end futuro), la frase va sin reloj. Sin este guion se ven el plazo de entrega y la nota, ciertos siempre.
   Fechas sin tramitar: una por línea, «AAAA-MM-DD» o «AAAA-MM-DD a AAAA-MM-DD»; lo que va detrás se ignora. Una línea mal escrita, o más de 60 días
   seguidos sin tramitar, y el bloque no se enseña (en el editor, avisa). En el editor se vuelve a armar con shopify:section:load. */
(() => {
  let timer = 0;
  const init = () => {
    clearInterval(timer);
    const el = document.querySelector('[data-ficha-corte]');
    if (!el) return;
    const C = JSON.parse(el.querySelector('[data-ficha-corte-data]').textContent);
    const main = el.querySelector('[data-ficha-corte-main]');
    const Z = 'Europe/Madrid', DAY = 864e5;
    const F = new Intl.DateTimeFormat('en-GB', { timeZone: Z, hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' });
    const W = new Intl.DateTimeFormat('es-ES', { timeZone: 'UTC', weekday: 'long' });
    const D = new Intl.DateTimeFormat('es-ES', { timeZone: 'UTC', day: 'numeric', month: 'long' });
    const at = (ms) => { const p = {}; F.formatToParts(ms).forEach((x) => (p[x.type] = +x.value)); return p; };
    const iso = (u) => new Date(u).toISOString().slice(0, 10);
    const R = [];
    let bad = 0;
    String(C.cerrado || '').split('\n').forEach((l) => {
      l = l.trim();
      if (!l) return;
      const m = /^(\d{4}-\d{2}-\d{2})(?:\s+a\s+(\d{4}-\d{2}-\d{2}))?(?:\s|$)/.exec(l);
      const a = m && Date.parse(m[1]), b = m && Date.parse(m[2] || m[1]);
      if (!m || !(a <= b) || iso(a) !== m[1] || iso(b) !== (m[2] || m[1])) bad++;
      else R.push([a, b]);
    });
    const closed = (u) => R.find(([a, b]) => u >= a && u <= b);
    const work = (u) => C.dias.includes(new Date(u).getUTCDay()) && !closed(u);
    const [H, M] = C.hora.split(':').map(Number);
    const fill = (t, o) => (t || '').replace(/\{(\w+)\}/g, (_, k) => (k in o ? o[k] : ''));
    const join = (...t) => t.filter(Boolean).join(' ');
    let last = '';
    const node = (tag, text, cls) => { const n = document.createElement(tag); n.textContent = text; if (cls) n.className = cls; return n; };
    // «10-20» sin partir por el guion (el navegador corta detrás de un guion entre cifras); el tiempo, en <strong> (\u0001 marca su sitio)
    const put = (text) => text.split(/(\d+-\d+)/).forEach((x, i) => x && main.append(i % 2 ? node('span', x, 'ficha-corte__nb') : x));
    const paint = (txt, tiempo) => {
      el.hidden = false;
      if (txt + tiempo === last) return;
      last = txt + tiempo;
      main.textContent = '';
      txt.split('\u0001').forEach((x, i) => {
        if (i) main.append(node('strong', tiempo));
        put(x);
      });
    };
    const tick = () => {
      const now = Date.now(), p = at(now), today = Date.UTC(p.year, p.month - 1, p.day);
      const wall = Date.UTC(p.year, p.month - 1, p.day, H, M), off = (ms) => { const q = at(ms); return Date.UTC(q.year, q.month - 1, q.day, q.hour, q.minute, q.second) - ms; };
      const left = wall - off(wall - off(now)) - now;
      if (work(today) && left > 0) {
        const live = [...document.querySelectorAll('[data-ficha-countdown]')].some((c) => c.dataset.end * 1000 > now);
        const mins = Math.floor(left / 6e4), h = Math.floor(mins / 60), m = mins % 60;
        const tiempo = mins < 1 ? 'menos de 1 min' : h ? (m ? `${h} h ${m} min` : `${h} h`) : `${m} min`;
        return paint(join(fill(live ? C.t.fijo : C.t.hoy, { tiempo: '\u0001', hora: C.hora }), C.t.entrega), tiempo);
      }
      let n = today + DAY, i = 0;
      while (!work(n) && i++ < 60) n += DAY;
      if (i > 60) return void (el.hidden = true);
      const gap = [];
      for (let u = today; u < n; u += DAY) if (closed(u)) gap.push(closed(u));
      const range = gap.find(([a, b]) => a !== b);
      const hol = gap.find(([a, b]) => a === b && C.dias.includes(new Date(a).getUTCDay()));
      const dia = W.format(n) + (gap.length ? ' ' + D.format(n) : '');
      if (range) return paint(fill(C.t.vacaciones, { desde: D.format(range[0]), hasta: D.format(range[1]), dia: D.format(n) }), '');
      if (hol && (hol[0] === today || hol[0] === today + DAY)) return paint(join(fill(C.t.festivo, { cuando: hol[0] === today ? 'Hoy' : 'Mañana', dia }), C.t.entrega), '');
      paint(join(fill(n === today + DAY ? C.t.manana : C.t.siguiente, { dia }), C.t.entrega), '');
    };
    if (bad) {
      if (window.Shopify && window.Shopify.designMode) main.textContent = `Corte de pedidos: ${bad} fecha(s) mal escrita(s). Fuera del editor, el bloque no se enseña.`;
      else el.hidden = true;
      return;
    }
    tick();
    timer = setInterval(tick, 15e3);
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
